import * as Api from '../../api'

export const fetchResultsToChart = (token, params, uri) => dispatch => {
  dispatch({ type: `FETCH_RESULTS_TO_CHARTS_START` })

  Api.fetchDataParams(token, 'results', params, uri)
    .then(({ data }) => dispatch({ type: `FETCH_RESULTS_TO_CHARTS_SUCCESS`, payload: { data } }))
    .catch(error => dispatch({ type: `FETCH_RESULTS_TO_CHARTS_FAIL`, payload: { error } }))
}
